<template>
    <div>
        <HeaderStock header="คลัง" :img_header="header_image" link_back="alllot"/>
        <MenuStockList/>
        <LotDetailOutEditList/>
    </div>
</template>

<script>
import HeaderImage from '@/assets/icon-stock.png'
import HeaderStock from '@/components/menuadmin/stock/stockheader/HeaderStock.vue'
import MenuStockList from '@/components/menuadmin/stock/stocklist/MenuStockList.vue'
import LotDetailOutEditList from '@/components/menuadmin/stock/stocklist/LotDetailOutEditList.vue'

export default {
    name:'lotDetailOutEdit',
    components:{
        HeaderStock,
        MenuStockList,
        LotDetailOutEditList,
    },
    data(){
        return{
            header_image:HeaderImage
        }
    }
}
</script>